import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { RootState } from "../store";
import { Category, Course, CourseWeb, CourseWebCreateEdit, CourseWebType, Teacher } from "../../types/slices/coursesWebType";

const initialState: CourseWebType = {
  status: ApiStatus.FETCHED,
  coursesWeb: [] as CourseWeb[],
  errorMessage: undefined,
  editCourseWeb: {} as CourseWebCreateEdit,
  selectedCourseWeb: {} as CourseWeb,
  openModal: false,
  isEdit: false,
  selectedCourse: {} as Course,
  courses: [],
  selectedCategory: {} as Category,
  selectedTeacher: {} as Teacher,
  teachers: [],
  categories: [],
};

const courseWebSlice = createSlice({
  name: "courseWeb",
  initialState,
  reducers: {
    onFetchCourseWeb(state, { payload }: { payload: CourseWeb[] }) {
      state.status = ApiStatus.FETCHED;
      state.coursesWeb = payload;
      state.errorMessage = undefined;
    },
    onFetchCourses(state, { payload }: { payload: Course[] }) {
      state.status = ApiStatus.FETCHED;
      state.courses = payload;
      state.errorMessage = undefined;
    },
    changeStatus(state, { payload }: { payload: ApiStatus }) {
      state.status = payload;
    },
    onSetEditCourseWeb(state, { payload }: { payload: CourseWebCreateEdit }) {
      state.editCourseWeb = payload;
    },
    onSetSelectedCourseWeb(state, { payload }: { payload: CourseWeb }) {
      state.selectedCourseWeb = payload;
    },
    onSetOpenModal(state, { payload }: { payload: boolean }) {
      state.openModal = payload;
    },
    onChangeIsEdit(state, { payload }: { payload: boolean }) {
      state.isEdit = payload;
    },
    onSetSelectedCourse(state, { payload }: { payload: Course }) {
      state.selectedCourse = payload;
    },
    onSetSelectedCategory(state, { payload }: { payload: Category }) {
      state.selectedCategory = payload;
    },
    onSetSelectedTeacher(state, { payload }: { payload: Teacher }) {
      state.selectedTeacher = payload;
    },
    onFetchTeachers(state, { payload }: { payload: Teacher[] }) {
      state.status = ApiStatus.FETCHED;
      state.teachers = payload;
      state.errorMessage = undefined;
    },
    onFetchCategories(state, { payload }: { payload: Category[] }) {
      state.status = ApiStatus.FETCHED;
      state.categories = payload;
      state.errorMessage = undefined;
    },
  },
});

export const selectCourseWebState = (state: RootState) => state.courseWebSlice;
export default courseWebSlice.reducer;

export const {
  onFetchCourseWeb,
  changeStatus,
  onSetEditCourseWeb,
  onSetSelectedCourseWeb,
  onSetOpenModal,
  onChangeIsEdit,
  onFetchCourses,
  onFetchTeachers,
  onFetchCategories,
  onSetSelectedCourse,
  onSetSelectedCategory,
  onSetSelectedTeacher,
} = courseWebSlice.actions;